var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
import { MATFILE_ENDLESS_TYPE } from 'pxc-editor-core/constants';
import Section from "pxc-editor-core/entities/Section";
import store from '@/store';
import { getConfig } from '@/config/runtimeConfig';
import { materialStorageApi, pxcPortalApi } from '@/endpoints/apiUrls';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';
import { getLaserOutputValue, getMarkingColorValue, toQueryParams } from '@/helpers';
var MATERIALS_WITH_MAGAZINE = [
    'EMLP-AL (100X60)',
    'EMLP-AL (27X15)',
    'EMLP-AL (27X18)',
    'EMLP-AL (27X27)',
    'EMLP-AL (49X15)',
    'EMLP-AL (60X15)',
    'EMLP-AL (60X30)',
    'EMLP-AL (85,6X54)',
    'EMP-AL (27X15)',
    'EMP-AL (27X18)',
    'EMP-AL (49X15)',
    'EMP-AL (60X15)',
    'EMP-AL (60X30)',
    'EMP-AL (85,6X54)',
    'EMSP-AL (39X15)',
    'EMSP-AL (50X15)',
    'EMSP-AL (50X30)',
    'EMSP-AL (75,6X54)',
    'EMSP-AL (90X60)',
    'WMTB-AL (29X8)',
    'WMTB-AL (40X15)',
    'WMTB-AL (60X15)',
    'WMTB-AL (D30)',
];
var getCmAmountValue = function () {
    var pages = store.getState().core.pages;
    var matfileTemplate = getBuildedMatfileTemplate();
    var isMaterialWithMagazine = MATERIALS_WITH_MAGAZINE.includes((matfileTemplate === null || matfileTemplate === void 0 ? void 0 : matfileTemplate.name) || '');
    var isEndlessMaterial = (matfileTemplate === null || matfileTemplate === void 0 ? void 0 : matfileTemplate.type) === MATFILE_ENDLESS_TYPE;
    if (isMaterialWithMagazine) {
        return Object.values(pages).reduce(function (result, page) {
            var sections = page.sections;
            var labelsWithContent = Object.values(sections).reduce(function (acc, section) {
                if (!acc[section.shieldId] && !Section.contentIsEmpty(section)) {
                    acc[section.shieldId] = 1;
                }
                return acc;
            }, {});
            var value = Object.values(labelsWithContent).reduce(function (prev, next) { return prev + next; }, 0);
            return result += value;
        }, 0);
    }
    else if (isEndlessMaterial) {
        return 1;
    }
    else {
        return Object.values(pages).reduce(function (acc, page) { return (acc += 1); }, 0);
    }
};
var getCmLengthValue = function () {
    var pages = store.getState().core.pages;
    var matfileTemplate = getBuildedMatfileTemplate();
    var isEndlessMaterial = (matfileTemplate === null || matfileTemplate === void 0 ? void 0 : matfileTemplate.type) === MATFILE_ENDLESS_TYPE;
    // if material category == endless (it´s in mat desc). Sum up the total material length of all pages in marking editor. Set to 0 if not endless
    if (isEndlessMaterial) {
        return Object.values(pages).reduce(function (acc, page) {
            return acc += page.box.r;
        }, 0);
    }
    return 0;
};
export default {
    getLatestReleasePackage: function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    url = materialStorageApi.latestReleasePackage();
                    return [4 /*yield*/, fetch(url).then(function (res) { return res.json(); })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_1 = _a.sent();
                    console.error('[getLatestReleasePackage]:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    // NOT USED
    getMaterialByMaterialName: function (releaseId, materialName) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    url = materialStorageApi.materialByName(releaseId, materialName);
                    return [4 /*yield*/, fetch(url).then(function (res) { return res.json(); })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_2 = _a.sent();
                    console.error('[getMaterialByMaterialName]:', error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    getMaterialByArticleNumber: function (releaseId, materialNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    url = materialStorageApi.materialByArticleNumber(releaseId, materialNumber);
                    return [4 /*yield*/, fetch(url).then(function (res) { return res.json(); })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_3 = _a.sent();
                    console.error('[getMaterialByArticleNumber]:', error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    // NOT USED
    getCustomersAccess: function (webComponentConfing) { return __awaiter(void 0, void 0, void 0, function () {
        var _realm, _locale, _token, params, url, request, response, access, customers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _realm = webComponentConfing.realm;
                    _locale = webComponentConfing.locale;
                    _token = webComponentConfing.authToken;
                    params = toQueryParams({ _realm: _realm, _locale: _locale });
                    url = pxcPortalApi.customersAccess(params);
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Authorization: "Bearer ".concat(_token),
                            },
                        })];
                case 1:
                    request = _a.sent();
                    response = request.data;
                    access = response.access.find(function (_a) {
                        var virtualPortal = _a.virtualPortal;
                        return virtualPortal === _realm;
                    });
                    customers = ((access === null || access === void 0 ? void 0 : access.customers) || []).reduce(function (acc, customer) {
                        if (customer.customerId && customer.customerName) {
                            return __spreadArray(__spreadArray([], __read(acc), false), [customer], false);
                        }
                        return acc;
                    }, []);
                    return [2 /*return*/, customers];
            }
        });
    }); },
    getCustomerAccounts: function (webComponentConfing) { return __awaiter(void 0, void 0, void 0, function () {
        var _realm, _locale, _token, params, url, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _realm = webComponentConfing.realm;
                    _locale = webComponentConfing.locale;
                    _token = webComponentConfing.authToken;
                    params = toQueryParams({ _realm: _realm, _locale: _locale, sort: 'RECENT', order: 'DSC', scope: 'CRISP' });
                    url = pxcPortalApi.customerAccounts(params);
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Authorization: "Bearer ".concat(_token),
                            },
                        })];
                case 1:
                    request = _a.sent();
                    response = request === null || request === void 0 ? void 0 : request.data;
                    return [2 /*return*/, response];
            }
        });
    }); },
    postCreateSolution: function (webComponentConfing, customerId) { return __awaiter(void 0, void 0, void 0, function () {
        var _realm, _locale, _token, params, url, body, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _realm = webComponentConfing.realm;
                    _locale = webComponentConfing.locale;
                    _token = webComponentConfing.authToken;
                    params = toQueryParams({ _realm: _realm, _locale: _locale });
                    url = pxcPortalApi.createSolution(params);
                    body = {
                        virtualPortal: _realm,
                        customerId: customerId,
                    };
                    return [4 /*yield*/, axios.post(url, body, {
                            headers: {
                                Authorization: "Bearer ".concat(_token),
                            },
                            responseType: 'text',
                        })];
                case 1:
                    request = _a.sent();
                    response = request.data;
                    return [2 /*return*/, response];
            }
        });
    }); },
    postProjectData: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var _realm, _locale, _token, params, url, request, response;
        var webComponentConfing = _b.webComponentConfing, createdSolutionId = _b.createdSolutionId, projectData = _b.projectData, filename = _b.filename;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _realm = webComponentConfing.realm;
                    _locale = webComponentConfing.locale;
                    _token = webComponentConfing.authToken;
                    params = toQueryParams({ filename: "".concat(filename, ".cmme"), _realm: _realm, _locale: _locale });
                    url = pxcPortalApi.solutionAttachments(createdSolutionId, params);
                    return [4 /*yield*/, axios.post(url, projectData, {
                            headers: {
                                Authorization: "Bearer ".concat(_token),
                                'Content-Type': 'application/octet-stream',
                            },
                            responseType: 'text',
                        })];
                case 1:
                    request = _c.sent();
                    response = request.data;
                    return [2 /*return*/, response];
            }
        });
    }); },
    putProjectData: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var _realm, _locale, _token, params, url, colorSchema, cmMatNr, cmMarkingColor, cmLaserOutput, cmAmount, cmLength, body, request, response;
        var webComponentConfing = _b.webComponentConfing, createdSolutionId = _b.createdSolutionId, filename = _b.filename;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _realm = webComponentConfing.realm;
                    _locale = webComponentConfing.locale;
                    _token = webComponentConfing.authToken;
                    params = toQueryParams({ _realm: _realm, _locale: _locale });
                    url = pxcPortalApi.solutionProjectData(createdSolutionId, params);
                    colorSchema = store.getState().core.colorSchema;
                    cmMatNr = colorSchema === null || colorSchema === void 0 ? void 0 : colorSchema.article_number;
                    cmMarkingColor = getMarkingColorValue();
                    cmLaserOutput = getLaserOutputValue();
                    cmAmount = getCmAmountValue();
                    cmLength = getCmLengthValue();
                    body = {
                        attachments: [],
                        complianceReportPath: '',
                        configurationId: '',
                        customerItemId: filename,
                        extension: 'cmme',
                        itemId: getConfig().projectDataItemId,
                        cmAmount: cmAmount,
                        cmLaserOutput: cmLaserOutput,
                        cmLength: cmLength,
                        cmMarkingColor: cmMarkingColor,
                        cmMarkingSystem: "",
                        cmMatNr: cmMatNr,
                        cmType: "",
                    };
                    return [4 /*yield*/, axios.put(url, body, {
                            headers: {
                                Authorization: "Bearer ".concat(_token),
                            },
                            responseType: 'text',
                        })];
                case 1:
                    request = _c.sent();
                    response = request.data;
                    return [2 /*return*/, response];
            }
        });
    }); },
    submitSolution: function (webComponentConfing, createdSolutionId) { return __awaiter(void 0, void 0, void 0, function () {
        var _realm, _locale, _token, params, url, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _realm = webComponentConfing.realm;
                    _locale = webComponentConfing.locale;
                    _token = webComponentConfing.authToken;
                    params = toQueryParams({ _realm: _realm, _locale: _locale });
                    url = pxcPortalApi.submitSolution(createdSolutionId, params);
                    return [4 /*yield*/, axios.post(url, null, {
                            headers: {
                                Authorization: "Bearer ".concat(_token),
                            },
                            responseType: 'text',
                        })];
                case 1:
                    request = _a.sent();
                    response = request.data;
                    return [2 /*return*/, response];
            }
        });
    }); },
    sendProjectPreview: function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var webComponentConfing, createdSolutionId, position, data, _realm, _locale, _token, params, url, request;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    webComponentConfing = payload.webComponentConfing, createdSolutionId = payload.createdSolutionId, position = payload.position, data = payload.data;
                    _realm = webComponentConfing.realm;
                    _locale = webComponentConfing.locale;
                    _token = webComponentConfing.authToken;
                    params = toQueryParams({ _realm: _realm, _locale: _locale });
                    url = pxcPortalApi.solutionPreviewImage(createdSolutionId, position, params);
                    return [4 /*yield*/, axios.put(url, data, {
                            headers: (_a = {
                                    Authorization: "Bearer ".concat(_token)
                                },
                                _a['Content-Type'] = 'image/png',
                                _a),
                        })];
                case 1:
                    request = _b.sent();
                    return [2 /*return*/];
            }
        });
    }); }
};
